module.exports = __webpack_public_path__ + "assets/media/msg-sent.f1db0e54.mp3";